import httpClient from '../lib/http-client'

const reportApi = {
  add (model) {
    return httpClient.post('/temp-report', model)
  },
  addFile (model) {
    return httpClient.post('/temp-report/file', model, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  retry (reportDataId, loginId, loginPassword) {
    const model = {
      reportDataId,
      loginId,
      loginPassword
    }
    return httpClient.post('/temp-report/retry', model)
  },
  findAll () {
    return httpClient.get('/temp-report')
  },
  findById (id) {
    return httpClient.get(`/temp-report/${id}`)
  },
  findByMainReportId (id) {
    return httpClient.get(`/temp-report/main/${id}`)
  },
  seeById (id) {
    return httpClient.get(`/temp-report/${id}/see`)
  },
  getQueue (id) {
    return httpClient.get(`/temp-report/queue`)
  },
  findCategoryResult (id, categoryId) {
    return httpClient.get(`/temp-report/${id}/${categoryId}`)
  },
  findProcessing () {
    return httpClient.get(`/temp-report/processing`)
  }
}

export default reportApi



// WEBPACK FOOTER //
// ./src/api/temp-report.js